import { downloadFileFromSignedUrl, fileActions, selectFilesById } from "@somewear/files";
import { grpc, someGrpc } from "@somewear/grpc";
import type {
	ActionSetEpic,
	DownloadFileRequestPayload,
	DownloadFileResponse,
} from "@somewear/model";
import { createMergingActionSetEpicHandler, haltAll } from "@somewear/model";
import type { RootState } from "@web/app/rootReducer";
import { defer, from } from "rxjs";
import { filter, finalize, map, mergeMap, startWith, switchMap } from "rxjs/operators";

/*
 * Download a file and dispatch the action to set it on the store
 */
export const downloadFileEpic: ActionSetEpic<
	DownloadFileRequestPayload,
	DownloadFileResponse,
	RootState
> = (action$, state$) =>
	action$.pipe(
		filter(haltAll.match),
		startWith(null),
		// Reset the entire scheduler on logout, including mergeMap's buffered requests.
		switchMap(() =>
			createMergingActionSetEpicHandler(
				action$,
				state$,
				fileActions.downloadFile,
				(payload) =>
					defer(() => {
						const controller = new AbortController();
						const file = selectFilesById(state$.value, payload.data.fileId);
						return grpc
							.prepareRequestWithPayload(someGrpc.downloadFile, payload.data)
							.pipe(
								mergeMap((response) =>
									from(
										downloadFileFromSignedUrl(
											response.toObject().signedDownloadUrl,
											payload.data.fileName ?? file?.name,
											controller.signal,
										),
									),
								),
								map(() => "success"),
								finalize(() => controller.abort()),
							);
					}),
				{ onRejected: "Error downloading file" },
				8,
			),
		),
	);
